import React, { MouseEventHandler } from "react";

import { Button } from "../../../../components/elements";
import "./AddToCartBtn.scss";
import "./AddToCartBtn_flint.scss";
import "./AddToCartBtn_kokoro.scss";
import "./AddToCartBtn_pdd.scss";
import "./AddToCartBtn_shabuDays.scss";
import "./AddToCartBtn_torikizoku.scss";
import "./AddToCartBtn_wang.scss";

interface IAddToCartBtnProps {
	onClick: MouseEventHandler<HTMLButtonElement>;
}

const AddToCartBtn: React.FC<IAddToCartBtnProps> = ({ onClick }) => {
	return <Button className="AddToCartButton" onClick={onClick} />;
};

export default AddToCartBtn;
